import Backbone from 'backbone'
import $ from 'jquery'

class SlideshowView extends Backbone.View {
    events () {
        return {
            'click .slideshow-nav.slideshow-nav-ant': 'prev',
            'click .slideshow-nav.slideshow-nav-prox': 'next',
            'click .slidesnum a': 'nav',
            'mouseover': 'stopTimer',
            'mouseout': 'startTimer'
        }
    }

    initialize (options) {
        this.$photos = this.$el.find('.slideitems li')
        this.$navs = this.$el.find('.slidesnum li')
        this.size = this.$photos.length
        this.current = 0

        this._timer()
    }

    prev (ev) {
        if (ev) {
            ev.preventDefault()
        }

        // Seta o novo current
        this._setPrevCurrent()

        // Processa a navegação
        this._process()
    }

    next (ev) {
        if (ev) {
            ev.preventDefault()
        }

        // Seta o novo current
        this._setNextCurrent()

        // Processa a navegação
        this._process()
    }

    nav (ev) {
        ev.preventDefault()

        this.current = $(ev.target).parent('li').index()
        this._process()
    }

    stopTimer (ev) {
        console.log(ev)
        ev.preventDefault()

        console.log('stopTimer')

        clearTimeout(this.timer)
    }

    startTimer (ev) {
        ev.preventDefault()

        this._timer()
    }

    _process () {
        // zera o timer
        clearTimeout(this.timer)

        // Esconde todas as fotos
        this.$photos.removeClass('active')

        // Remove todas as classes
        this.$navs.removeClass('active')

        // Processa a imagem
        this.$photos.eq(this.current).addClass('active')
        this.$navs.eq(this.current).addClass('active')

        // chama novamente o timer
        this._timer()
    }

    _setNextCurrent () {
        if (this.current === (this.size - 1)) {
            this.current = 0
            return
        }

        this.current++
    }

    _setPrevCurrent () {
        if (this.current === 0) {
            this.current = this.size - 1
            return
        }

        this.current--
    }

    _timer () {
        // Adicio o next a cada 9000 ms
        this.timer = setTimeout(() => {
            this.next()
        }, 9000)
    }
}

export default SlideshowView
